/* eslint-disable */
// /src/pages/EduDetailPage.jsx
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useParams } from "react-router-dom";
import BrandHeader from "../components/BrandHeader";
import PageTopBar from "../components/PageTopBar";
import { getEduPublic } from "../services/eduPublicService";

const Wrap = styled.div`
  min-height:100vh;
  background:linear-gradient(180deg,#D7E8FF 0%, #EAF3FF 100%);
  display:flex;
  flex-direction:column;
`;
const Sheet = styled.div`
  background:#F7FAFF;
  box-shadow:0 -4px 20px rgba(0,0,0,.05);
  min-height:100dvh;
  display:flex;
  flex-direction:column;
`;
const Body = styled.div`
  flex:1;
  padding:16px;
  display:grid;
  grid-template-rows:auto 1fr auto;
  row-gap:14px;
`;

const Article = styled.article`
  background:#fff;
  border-radius:16px;
  box-shadow:0 1px 10px rgba(0,0,0,.06);
  padding:16px 14px;
  overflow:hidden;
`;
const Title = styled.h1`
  margin:0 0 6px;
  font-size:18px;
  font-weight:900;
  color:#0f172a;
`;
const Meta = styled.div`
  font-size:12px;
  color:#64748b;
  margin-bottom:10px;
`;
const Cover = styled.img`
  width:100%;
  height:auto;
  border-radius:10px;
  margin:8px 0 12px;
`;

// 🔹 영상 플레이어 스타일
const VideoBox = styled.div`
  position:relative;
  width:100%;
  border-radius:12px;
  overflow:hidden;
  background:#000;
  margin:8px 0 12px;
  box-shadow:0 8px 20px rgba(15,23,42,.35);
`;
const VideoFrame = styled.iframe`
  width:100%;
  aspect-ratio:16 / 9;
  border:0;
`;
const VideoTag = styled.video`
  width:100%;
  max-height:60vh;
  display:block;
  border-radius:12px;
`;

const Content = styled.div`
  color:#0f172a;
  line-height:1.65;
  font-size:14px;
  img{max-width:100%;height:auto;border-radius:8px}
  h1,h2,h3{margin:.8em 0 .4em}
  p{margin:.4em 0}
  ul{padding-left:18px}
`;

const BottomPad = styled.div`
  height:max(24px, env(safe-area-inset-bottom));
`;

function fmt(d) {
    try {
        return (d instanceof Date ? d : new Date(d)).toISOString().slice(0, 10);
    } catch {
        return "-";
    }
}

// 🔹 YouTube / Shorts URL이면 embed 주소로 변환, 아니면 null
function toYoutubeEmbedUrl(url) {
    if (!url) return null;
    const raw = String(url).trim();

    // 1) shorts: youtube.com/shorts/<id>
    let m = raw.match(/youtube\.com\/shorts\/([^?&#/]+)/);
    if (m && m[1]) {
        return `https://www.youtube.com/embed/${m[1]}`;
    }

    // 2) youtu.be/<id>
    m = raw.match(/youtu\.be\/([^?&#/]+)/);
    if (m && m[1]) {
        return `https://www.youtube.com/embed/${m[1]}`;
    }

    // 3) youtube.com/watch?v=<id>
    m = raw.match(/[?&]v=([^?&#/]+)/);
    if (m && m[1]) {
        return `https://www.youtube.com/embed/${m[1]}`;
    }

    // 4) 이미 embed 주소면 그대로 사용
    if (/youtube\.com\/embed\//.test(raw)) {
        return raw;
    }

    // 유튜브 계열이 아니면 null
    if (!/youtube\.com|youtu\.be/.test(raw)) {
        return null;
    }

    // 혹시라도 이상한 형태면 raw를 그대로 써보긴 함 (마지막 폴백)
    return raw;
}

export default function EduDetailPage() {
    const { id } = useParams();
    const [doc, setDoc] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        (async () => {
            try {
                setLoading(true);
                const v = await getEduPublic(id);
                setDoc(v);
            } finally {
                setLoading(false);
            }
        })();
    }, [id]);

    const rawVideoUrl = (doc?.videoUrl || "").trim();
    const youtubeEmbedUrl = rawVideoUrl ? toYoutubeEmbedUrl(rawVideoUrl) : null;

    return (
        <Wrap>
            <Sheet>
                <PageTopBar variant="back" label="뒤로" />

                <Body>
                    {/* <BrandHeader subtitle="교육 자료" /> */}

                    <Article>
                        {loading && (
                            <div style={{ padding: 12, color: "#64748b" }}>
                                불러오는 중…
                            </div>
                        )}

                        {!loading && !doc && (
                            <div style={{ padding: 12, color: "#b91c1c" }}>
                                해당 자료를 찾을 수 없습니다.
                            </div>
                        )}

                        {!loading && doc && (
                            <>
                                <Title>{doc.title}</Title>
                                <Meta>{fmt(doc.publishedAt)}</Meta>

                                {/* 🔹 영상이 있으면 먼저 표시 */}
                                {rawVideoUrl && (
                                    <VideoBox>
                                        {youtubeEmbedUrl ? (
                                            <VideoFrame
                                                src={youtubeEmbedUrl}
                                                title={doc.title}
                                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                                allowFullScreen
                                            />
                                        ) : (
                                            <VideoTag
                                                controls
                                                playsInline
                                                src={rawVideoUrl}
                                            />
                                        )}
                                    </VideoBox>
                                )}

                                {/* 🔹 영상이 없을 때만 이미지 커버 사용 */}
                                {!rawVideoUrl && doc.imageUrl ? (
                                    <Cover src={doc.imageUrl} alt="" />
                                ) : null}

                                <Content
                                    dangerouslySetInnerHTML={{
                                        __html: doc.bodyHtml || "",
                                    }}
                                />
                            </>
                        )}
                    </Article>

                    <BottomPad />
                </Body>
            </Sheet>
        </Wrap>
    );
}
